import {withNaming} from '@bem-react/classname';

export const bem = withNaming({n: 'slx-', e: '__', m: '--', v: '--'});

export const jsClass = (c) => `slx-js-${c}`;
